module.exports = __webpack_public_path__ + "img/clean-code.ca32855b.svg";